import { ActionTree, GetterTree, MutationTree } from 'vuex';

import {
  RewardRatioPayload,
  RewardsProgramFormState,
  RewardsProgramState
} from '@/models/rewards-program';
import { IRouterProps } from '@/router/interfaces/router-props.interface';

import { RootState } from '../types';
import Module from '../interfaces/module.interface';

const initialState = (): RewardsProgramState => ({
  formData: {
    address: null,
    aditionalAddress: '',
    posSystem: {
      provider: '',
      link: '',
      links: undefined
    }
  }
});

const factory = async (context: IRouterProps) => {};

const getters: GetterTree<RewardsProgramState, RootState> = {
  getFormData: state => state.formData
};

const actions: ActionTree<RewardsProgramState, RootState> = {
  SET_FORM_DATA({ commit }, payload: Partial<RewardsProgramFormState>) {
    commit('setFormData', payload);
  },
  SET_REWARD_RATIO_PAYLOAD({ commit }, payload: RewardRatioPayload) {
    commit('setRewardRatioPayload', payload);
  },
  RESET_FORM_DATA({ commit }) {
    commit('resetFormData');
  }
};

const mutations: MutationTree<RewardsProgramState> = {
  setFormData(state, formData: Partial<RewardsProgramFormState>) {
    Object.assign(state.formData, formData);
  },
  setRewardRatioPayload(state, payload: RewardRatioPayload) {
    state.formData.rewardRatioPayload = payload;
  },
  resetFormData(state) {
    Object.assign(state, initialState());
  }
};

export const rewardsProgram: Module<RewardsProgramState, RootState> = {
  namespaced: true,
  initializer: {
    factory,
    provide: 'RewardsProgramStore',
    on: 'BeforeEachRoute'
  },
  state: initialState(),
  getters,
  actions,
  mutations
};
